import { render, staticRenderFns } from "./verify-token.vue?vue&type=template&id=1b851e14"
import script from "./verify-token.vue?vue&type=script&lang=js"
export * from "./verify-token.vue?vue&type=script&lang=js"
import style0 from "./verify-token.vue?vue&type=style&index=0&id=1b851e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports